import React, { useState, useMemo } from 'react';

import { Field } from '@klarna/bubble-ui';
import { FieldProps } from '@bubble-ui/molecule-field-regular/types/types';
import { EncryptedString } from '@mjolnir/mf-fields-ts/src/types/Field.type';

const MASK = '**********';

const isEncryptedString = (o: any): o is EncryptedString =>
  typeof o === 'object' &&
  (typeof o.encrypted === 'undefined' || typeof o.encrypted === 'string') &&
  (typeof o.clear_text === 'undefined' || typeof o.clear_text === 'string');

interface EncryptedInputProps
  extends Omit<Omit<Omit<FieldProps, 'onChange'>, 'value'>, 'onComponentRef'> {
  onChange: (value: EncryptedString) => void;
  value?: EncryptedString;
}

export const EncryptedInput = ({
  onBlur = () => {},
  onChange = () => {},
  onFocus = () => {},
  value,
  ...inputProps
}: EncryptedInputProps) => {
  const [editing, setEditing] = useState(false);
  const [innerValue, setInnerValue] = useState(isEncryptedString(value) ? MASK : '');

  const _onChange = (clearValue: string) => {
    setInnerValue(clearValue);
    onChange(clearValue.length ? { clear_text: clearValue } : {});
  };

  const _onFocus = event => {
    setEditing(true);
    setInnerValue('');
    onFocus(event);
  };

  const _onBlur = event => {
    setEditing(false);
    _onChange(innerValue);
    onBlur(event);
  };

  const visibleValue = useMemo(() => (innerValue.length ? (editing ? innerValue : MASK) : ''), [
    editing,
    innerValue,
  ]);

  return (
    <Field
      {...inputProps}
      value={visibleValue}
      onChange={_onChange}
      onFocus={_onFocus}
      onBlur={_onBlur}
      isUnderlined
    />
  );
};

EncryptedInput.propTypes = {
  ...Field.propTypes,
};
